// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-campaign-page-js": () => import("./../../../src/templates/campaign-page.js" /* webpackChunkName: "component---src-templates-campaign-page-js" */),
  "component---src-templates-landing-page-belgium-js": () => import("./../../../src/templates/landing-page-belgium.js" /* webpackChunkName: "component---src-templates-landing-page-belgium-js" */),
  "component---src-templates-landing-page-js": () => import("./../../../src/templates/landing-page.js" /* webpackChunkName: "component---src-templates-landing-page-js" */)
}

